"use client";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./IB7YUKH5.js";
import {
  createStoreContext
} from "./3ORBWXWF.js";

// src/toolbar/toolbar-context.tsx
var ctx = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useToolbarContext = ctx.useContext;
var useToolbarScopedContext = ctx.useScopedContext;
var useToolbarProviderContext = ctx.useProviderContext;
var ToolbarContextProvider = ctx.ContextProvider;
var ToolbarScopedContextProvider = ctx.ScopedContextProvider;

export {
  useToolbarContext,
  useToolbarScopedContext,
  useToolbarProviderContext,
  ToolbarContextProvider,
  ToolbarScopedContextProvider
};
